import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import { TabView, TabPanel } from "primereact/tabview";
import "./EquipementsPage.css";
import {
  BRAND,
  CREATED_AT,
  MODEL,
  MY_LUMINOUS,
  MY_PRINTERS,
  MY_RELAY_SWITCHES,
  MY_SENSOR,
  MY_SOS_BUTTONS,
  MY_STYLUS,
  MY_SUNSHIELDS,
  SERIAL_NUMBER,
  STATUS,
} from "Constant";

import Breadcrumbs from "Components/Breadcrumbs";
import Translate from "Components/Translate";
import SimpleDataTable from "Components/DataTables/SimpleDataTable";

const EquipementsPage = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  
  const listOfquipments = [
    {
      title: MY_PRINTERS,
      icon: "pi pi-print mr-2",
      list: "/front/printers?index=-1",
    },
    {
      title: MY_SUNSHIELDS,
      icon: "pi pi-sun mr-2",
      list: "/front/sunshields?index=-1",
    },
    {
      title: MY_SENSOR,
      icon: "pi pi-compass mr-2",
      list: "/front/sensors?index=-1",
    },
    {
      title: MY_STYLUS,
      icon: "pi pi-pencil mr-2",
      list: "/front/styluses?index=-1",
    },
    {
      title: MY_LUMINOUS,
      icon: "pi pi-lightbulb mr-2",
      list: "/front/luminouses?index=-1",
    },
    {
      title: MY_SOS_BUTTONS,
      icon: "pi pi-bell mr-2",
      list: "/front/sosButtons?index=-1",
    },
    {
      title: MY_RELAY_SWITCHES,
      icon: "pi pi-power-off mr-2",
      list: "/front/relaySwitches?index=-1",
    },
  ];

  return (
    <Card>
      <CardBody>
        <TabView 
          scrollable 
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          {listOfquipments.map((elem, i) => {
            const { title, icon, list } = elem;
            const header = (
              <span className="flex align-items-center gap-2">
                <i className={icon}></i>
                <Translate>{title}</Translate>
              </span>
            );
            return (
              <TabPanel key={i} header={header}>
                <div className="p-4">
                  <Breadcrumbs breadCrumbsProps={[title]} />

                  <SimpleDataTable
                    createBtn={false}
                    newColumns={[
                      {
                        name: BRAND,
                        selector: "brand",
                      },
                      {
                        name: MODEL,
                        selector: "model",
                      },
                      {
                        name: STATUS,
                        selector: "status",
                      },
                      {
                        name: SERIAL_NUMBER,
                        selector: "serial_number",
                      },
                      {
                        name: CREATED_AT,
                        selector: "created_at",
                      },
                    ]}
                    link={list}
                  />
                </div>
              </TabPanel>
            );
          })}
        </TabView>
      </CardBody>
    </Card>
  );
};

export default EquipementsPage;
